import React from 'react';
import { Color, COLORS } from '../../styles/variables';

interface MapIconProps {
  color?: Color;
}

const FiltersIcon: React.FC<MapIconProps> = ({ color = COLORS.black }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 4.5H20.5L14.1 11.9C13.7 12.3 13.5 12.8 13.5 13.3V18.5L10.5 20.5V13.3C10.5 12.8 10.3 12.3 9.9 11.9L3.5 4.5Z"
        stroke={color}
      />
    </svg>
  );
};

export default FiltersIcon;
